import React, { VFC } from 'react';

import { Text } from '@fhs-legacy/universal-components';
import { Calories } from 'components/price-and-calories';
import { useMenuCalories } from 'hooks/menu/use-menu-calories';
import { useProductPrice } from 'hooks/menu/use-product-price';
import { computeProductCalories } from 'hooks/menu/utils';
import { useProductWizardContext } from 'state/product-wizard';

import { PriceAndCaloriesText } from './price-and-calories.styled';

export const PriceAndCalories: VFC = () => {
  const { formattedProductPrice } = useProductPrice();

  const { selectedProduct } = useProductWizardContext();
  const { formatCalories } = useMenuCalories();

  const shouldComputeCalories = !!selectedProduct && !selectedProduct.hideCalories;
  const productCalories = shouldComputeCalories ? computeProductCalories(selectedProduct) : 0;
  const formattedProductCalories = formatCalories(productCalories);

  return (
    <PriceAndCaloriesText>
      <Text variant="copyOne" testID="product-total-price">
        {formattedProductPrice}
      </Text>
      <Calories hideCalories={!!selectedProduct?.hideCalories}>
        <Text variant="copyOne" testID="product-total-calories">
          <Text variant="copyOne"> • </Text>
          {formattedProductCalories}
        </Text>
      </Calories>
    </PriceAndCaloriesText>
  );
};

export default PriceAndCalories;
